import './sketchColorPicker.less'

import React, {useCallback, useEffect, useState} from "react";
import classnames from 'classnames';
import {ColorResult, SketchPicker, SketchPickerProps} from 'react-color';
import {AntPopover} from "controls/react/ant/antPopover";
import {Link} from 'core/react/links';
import {observer} from 'mobx-react';
import {captureValueLink} from '../ant/utils';
import {Button} from "controls/react/form";
import {hexToRgba, rgbaToHex} from "tools/colorHelpers";


interface SketchColorPickerProps extends SketchPickerProps{
	valueLink?: Link<ColorResult>
	value?: ColorResult
	disableAlpha?: boolean
}

const b = require('b_').with('sketch-color-picker')

export const SketchColorPicker = observer((props: SketchColorPickerProps) => {
	props = captureValueLink(props);
	let { className, value, disableAlpha, onChange, ...nativeProps} = props


	const classes = classnames(className)


	return <div className={b()}>
			<AntPopover
				placement="bottomLeft"
				content={<SketchPicker className={classes} disableAlpha={disableAlpha ?? true} color={value?.hex} onChange={onChange} {...nativeProps} width={"265px"}/>}
				trigger="click">
				<Button onClick={()=>{}}
						style={{backgroundColor: value?.hex}}
						className={b("picker-btn")}/>
			</AntPopover>
		</div>
});


interface SketchColorPickerPlainProps extends Omit<SketchPickerProps, 'onChange'>{
	value?: string
	onChange?: ((color: string, event: React.ChangeEvent<HTMLInputElement>) => void );
}

export const SketchColorPickerPlain = observer((props: SketchColorPickerPlainProps) => {
	let { className, value, onChange,  ...nativeProps} = props

	const onChangeWrapper = React.useCallback((color: ColorResult,  event: React.ChangeEvent<HTMLInputElement>) => {
		onChange(color.hex, event)
	}, [onChange])

	const classes = classnames(className)


	return <div className={b()}>
		<AntPopover
			placement="bottomLeft"
			content={<SketchPicker className={classes} color={value} disableAlpha={true} onChange={onChangeWrapper} {...nativeProps} width={"265px"}/>}
			trigger="click">
			<Button onClick={()=>{}}
			        style={{backgroundColor: value}}
			        className={b("picker-btn")}/>
		</AntPopover>
	</div>
});

export type CvColorPickerProps = {
	value?: string;
	onChange?: (color: string) => void;
	disableAlpha?: boolean
}


export const CvColorPicker = observer(({value, onChange, disableAlpha}: CvColorPickerProps) => {
	const [color, setColor] = useState<ColorResult>({hex: value, rgb: value ? hexToRgba(value) : undefined, hsl: undefined});
	useEffect(() => {
		setColor({hex: value, rgb: value ? hexToRgba(value) : undefined, hsl: undefined})
	}, [value]);

	const updateColor = useCallback((val: ColorResult) => {
		val.hex = val.rgb ? rgbaToHex(val.rgb.r, val.rgb.g, val.rgb.b, val.rgb.a) : val.hex;
		setColor(val);
	}, [])

	const onComplete = useCallback((val: ColorResult) => {
		val.hex = val.rgb ? rgbaToHex(val.rgb.r, val.rgb.g, val.rgb.b, val.rgb.a) : val.hex;
		onChange?.(val.hex);
	}, [])

	return <SketchColorPicker value={color} onChange={updateColor} onChangeComplete={onComplete} disableAlpha={disableAlpha ?? false} />
})
